export default "__VITE_ASSET__JYzJB3vl__"